import React from 'react';
import penthouseImg  from '@/assets/experience/penthouse.webp';
import wineImg       from '@/assets/experience/wine.webp';
import dinnerImg     from '@/assets/experience/dinner.webp';
import musicImg      from '@/assets/experience/Live_Music_APPROVED_EXACT.png';
import fireplaceImg  from '@/assets/experience/Grand_Fireplace_APPROVED_EXACT.png';
import attireImg     from '@/assets/experience/Dress_To_Impress_APPROVED_EXACT.png';

const highlights = [
  { img: penthouseImg, alt: 'Exclusive 3-story penthouse rooftop at night', title: 'Exclusive 3-Story Penthouse', desc: 'Outdoor Patios with City Views', testId: 'highlight-penthouse'  },
  { img: wineImg,      alt: 'Complimentary wine bar',                        title: 'Complimentary Wine Bar',       desc: 'International Selections',    testId: 'highlight-wine'       },
  { img: dinnerImg,    alt: 'Curated surf and turf dinner buffet',           title: 'Curated Dinner Buffet',        desc: 'Surf & Turf Selections',      testId: 'highlight-dinner'     },
  { img: musicImg,     alt: 'Saxophone and microphone on a jazz lounge stage', title: 'Live Music',                  desc: 'Soul, Funk & Jazz Jam Session',testId: 'highlight-music'      },
  { img: fireplaceImg, alt: 'Elegant penthouse fireplace with city view',    title: 'Grand Fireplace',              desc: 'Warm & Festive Ambiance',     testId: 'highlight-fireplace'  },
  { img: attireImg,    alt: 'Black tuxedo and gold sequin dress for cocktail attire', title: 'Dress to Impress',    desc: 'Festive Cocktail Attire',     testId: 'highlight-dresscode'  },
];

const HighlightsSection = () => (
  <>
    {/* Green celebration band — a cinematic hand-off out of the hero */}
    <div className="lux-quote" data-testid="venue-spotlight">
      <div className="lux-quote__inner">
        <h2 className="lux-quote__heading">
          A Celebration of Appreciation, Manifestation &amp; Elevation
        </h2>
        <div className="lux-quote__sub">
          <span>Appreciate &amp; Celebrate 2026</span>
          <span className="lux-quote__diamond" aria-hidden="true">✦</span>
          <span>Manifest &amp; Elevate 2027</span>
        </div>
      </div>
    </div>

    {/* The Experience */}
    <section className="lux-experience" data-testid="highlights-section">
      <div className="lux-experience__intro">
        <div className="lux-eyebrow lux-eyebrow--onDark">
          <span className="lux-rule lux-rule--onDark" aria-hidden="true" />
          What Awaits You
          <span className="lux-rule lux-rule--onDark" aria-hidden="true" />
        </div>
        <h2 className="lux-heading lux-heading--onDark">The Experience</h2>
        <p className="lux-sub lux-sub--onDark">Three floors of Elegance, Warmth and Music</p>
      </div>

      <div className="lux-experience__grid">
        {highlights.map(({ img, alt, title, desc, testId }, i) => (
          <article key={testId} className="lux-card lux-card--photo" data-testid={testId}>
            <div className="lux-card__photo-wrap" aria-hidden="true">
              <img
                src={img}
                alt={alt}
                className="lux-card__photo"
                loading={i < 3 ? 'eager' : 'lazy'}
              />
            </div>
            <h3 className="lux-card__title">{title}</h3>
            <p className="lux-card__desc">{desc}</p>
            <div className="lux-card__hairline" aria-hidden="true" />
          </article>
        ))}
      </div>

      {/* The Evening — vertical schedule timeline */}
      <div className="lux-schedule" data-testid="evening-schedule">
        <div className="lux-schedule__header">
          <div className="lux-eyebrow lux-eyebrow--onDark">
            <span className="lux-rule lux-rule--onDark" aria-hidden="true" />
            Schedule of Celebration
            <span className="lux-rule lux-rule--onDark" aria-hidden="true" />
          </div>
          <h3 className="lux-schedule__title">The Evening</h3>
          <p className="lux-schedule__sub">
            You'll need to arrive before 7pm to experience our full Schedule of Celebration.
          </p>
        </div>

        <ol className="lux-schedule__list">
          <li className="lux-schedule__item" data-testid="schedule-6pm">
            <span className="lux-schedule__dot" aria-hidden="true" />
            <span className="lux-schedule__time">6&thinsp;PM</span>
            <span className="lux-schedule__sep" aria-hidden="true">—</span>
            <span className="lux-schedule__event">Doors Open</span>
          </li>
          <li className="lux-schedule__item" data-testid="schedule-7pm">
            <span className="lux-schedule__dot" aria-hidden="true" />
            <span className="lux-schedule__time">7&thinsp;PM</span>
            <span className="lux-schedule__sep" aria-hidden="true">—</span>
            <span className="lux-schedule__event">Dinner &amp; Live Band</span>
          </li>
          <li className="lux-schedule__item" data-testid="schedule-745pm">
            <span className="lux-schedule__dot" aria-hidden="true" />
            <span className="lux-schedule__time">7:45&thinsp;PM</span>
            <span className="lux-schedule__sep" aria-hidden="true">—</span>
            <span className="lux-schedule__event">Founder's Welcome &amp; Recognitions</span>
          </li>
          <li className="lux-schedule__item" data-testid="schedule-8pm">
            <span className="lux-schedule__dot" aria-hidden="true" />
            <span className="lux-schedule__time">8&thinsp;PM</span>
            <span className="lux-schedule__sep" aria-hidden="true">—</span>
            <span className="lux-schedule__event">Grown &amp; Sexy Dance Party</span>
          </li>
        </ol>
      </div>
    </section>

    {/* Red celebration band — pairs with the green band above */}
    <aside className="lux-dresscode" data-testid="dresscode-strip">
      <div className="lux-dresscode__inner">
        <h2 className="lux-dresscode__title">
          An Evening to Connect &amp; Indulge
        </h2>
        <div className="lux-dresscode__sub">
          <span>Laugh</span>
          <span className="lux-dresscode__diamond" aria-hidden="true">✦</span>
          <span>Eat</span>
          <span className="lux-dresscode__diamond" aria-hidden="true">✦</span>
          <span>Drink</span>
          <span className="lux-dresscode__diamond" aria-hidden="true">✦</span>
          <span>Dance</span>
        </div>
      </div>
    </aside>
  </>
);

export default HighlightsSection;
